export async function fetchLiveVideos() {
  try {
    const res = await fetch(
      'https://live-checker-7b277-default-rtdb.firebaseio.com/liveStreams.json'
    );
    const data = await res.json();

    const result = {};

    for (const [chanId, { videoId, thumbnail, name, title, channelId }] of Object.entries(data || {})) {
      result[name] = {
        live: {
          videoId,
          thumbnail,
          title,
          channelId: channelId || chanId,
        },
        recent: [],
      };
    }

    return result;
  } catch (err) {
    console.error('❌ Failed to fetch from Firebase:', err);
    return {};
  }
}